import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";
import BackMethods from "../back_component/BackMethods";

const DashboardLayout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { token, logout } = BackMethods();
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div dir="rtl ">
      <Navbar toggleSidebar={toggleSidebar} token={token} logout={logout} />
      <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />
      <main
        className=""
        style={{

          marginRight: isOpen ? "264px" : "0",
          transition: "margin-right 0.3s ease-in-out",
        }}
      >
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
